import React, { useEffect, useState } from 'react';
import styles from 'routes/vendorRe/pages/VendorCalc.module.css';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import depthMove from 'routes/vendorRe/images/depth_move_icon.png';
import {
    commonBgColor,
    commonBodyPadding,
    commonFontWeight700,
    commonH1Padding,
    commonH1Size,
    contentCenter,
    contentEnd,
    contentStart,
    infoEm,
    infoFontColor1,
    infoFontColor2,
    infoFontColor3,
    infoFontSize1,
    statsOuterPadding,
    statsPaddingEnd,
    statsPaddingMiddle,
    statsPaddingStart,

} from 'routes/vendorRe/constraint/constraints';
import { requester } from 'App';

const VendorCalc = (props) => {
    const [isMounted, setMounted] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const [cardCommission, setCardCommission] = useState(0);
    const [vat, setVat] = useState(0);
    const [monthSettlementAmount, setMonthSettlementAmount] = useState(0);
    const date = new Date();
    // 현재 년도와 월을 관리하는 상태
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const [displayYear, setDisplayYear] = useState(currentYear);
    const [displayMonth, setDisplayMonth] = useState(currentMonth + 1);

    // 월 단위로 데이터를 조회하고 업데이트하는 함수
    const updateMonth = (direction) => {
        let newMonth = displayMonth + direction;
        let newYear = displayYear;

        // 월이 0 또는 11을 초과하면 년도를 조정
        if (newMonth < 1) { // 월이 1 미만이면 년도를 하나 감소
            newMonth = 12; // 12월로 설정
            newYear -= 1; // 년도를 하나 감소
        } else if (newMonth > 12) { // 월이 12 초과이면 년도를 하나 증가
            newMonth = 1; // 1월로 설정
            newYear += 1; // 년도를 하나 증가
        }

        setDisplayMonth(newMonth);
        setDisplayYear(newYear);

        // 여기서 데이터 조회 및 업데이트 로직을 추가할 수 있습니다.
        let yearAndMonthData = { year: newYear, month: newMonth }
        
        requester.getVendorSettlementFeeByYearAndMonth(yearAndMonthData, (result) => {
            
            setTotalAmount(result.data);

            // 테스트용 카드 수수료 계산
            const cardCommission = result.data.totalAmount * cardCommissionRate;
            setCardCommission(cardCommission);

            // 테스트용 부가세 계산
            const vat = Math.floor((result.data.totalAmount - cardCommission) * vatRate);
            setVat(vat);
            let total = result.data.totalAmount - cardCommission - vat;
            setMonthSettlementAmount(Math.floor(total));
        })
        // 예: API 호출 등
    };

    // 테스트용 물품 대금 변수


    // 카드 수수료 비율
    const cardCommissionRate = 0.033;

    // 부가세 비율
    const vatRate = 0.1;

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            requester.getVendorSettlementFee((result) => {
                
                setTotalAmount(result.data);

                // 이번 달의 데이터 가져오기
                // const filteredMonthData = filterDataByThisMonth(result.data);


                // 테스트용 카드 수수료 계산(어차피 PA사에서 데이터 넘어옴)
                const cardCommission = result.data.totalAmount * cardCommissionRate;
                setCardCommission(cardCommission);

                // 테스트용 부가세 계산
                const vat = Math.floor((result.data.totalAmount - cardCommission) * vatRate);
                setVat(vat);
                let total = result.data.totalAmount - cardCommission - vat;
                setMonthSettlementAmount(Math.floor(total));
            })

        }
    }, [isMounted]);

    return (
        <Container backgroundColor={commonBgColor} height={props.web ? null : "90vh"}>
            <div style={{height: "10vh"}}></div>
            <VerticalFlex backgroundColor={commonBgColor}>
                <FlexChild padding={props.web ? null : commonBodyPadding} alignItems={contentStart}>
                    <VerticalFlex>
                        <FlexChild alignItems={contentStart}>
                            {
                                props.web ?
                                    null
                                    :
                                    <P padding={commonH1Padding} size={commonH1Size}>정산 금액 조회</P>

                            }

                            <VerticalFlex backgroundColor="white" borderRadius={infoEm} padding={statsOuterPadding} >
                                <FlexChild padding={statsPaddingStart}>
                                    <HorizontalFlex>
                                        <FlexChild justifyContent={contentStart}>
                                            <img
                                                style={{ transform: "rotate(180deg)" }}
                                                className={styles.depthMove}
                                                src={depthMove}
                                                alt='뎁스 이동'
                                                onClick={() => updateMonth(-1)} // 좌측 이미지 클릭 시 이전 월로 이동
                                            />
                                        </FlexChild>
                                        <FlexChild justifyContent={contentCenter} width={"max-content"}>
                                            <P weight={commonFontWeight700} size={"min(3.3vw, 25px)"} >
                                            {displayYear}년 {new Date(displayYear, displayMonth - 1).toLocaleString('ko-KR', { month: 'long' })} 정산 예정 금액
                                            </P>
                                        </FlexChild>
                                        <FlexChild justifyContent={contentEnd}>
                                            <img
                                                className={styles.depthMove}
                                                src={depthMove}
                                                alt='뎁스 이동'
                                                onClick={() => updateMonth(1)} // 우측 이미지 클릭 시 다음 월로 이동
                                            />
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <div className={styles.borderTop}>
                                        <VerticalFlex>
                                            <FlexChild flex="1" padding={statsPaddingMiddle}>
                                                <HorizontalFlex>
                                                    <FlexChild >
                                                        <P size={infoFontSize1} color={infoFontColor1}>이달 매출</P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor1}>{totalAmount ? totalAmount.totalPrice.toLocaleString() : 0}</P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild flex="1" padding={statsPaddingMiddle}>
                                                <HorizontalFlex>
                                                    <FlexChild >
                                                        <P size={infoFontSize1} color={infoFontColor1}>물품 대금</P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor1}>
                                                            {totalAmount && totalAmount.totalsupplyPrice ? (`- `) + totalAmount.totalsupplyPrice.toLocaleString() : 0}
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild flex="1" padding={statsPaddingMiddle}>
                                                <HorizontalFlex>
                                                    <FlexChild >
                                                        <P size={infoFontSize1} color={infoFontColor1}>카드 수수료</P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor1}>
                                                            {/* 카드 수수료가 있으면 '-' 기호를 붙임 */}
                                                            {cardCommission ? '- ' : ''}
                                                            {/* 카드 수수료의 절댓값을 취하고 숫자를 포맷팅하여 출력 */}
                                                            {Math.abs(cardCommission).toLocaleString()}
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild flex="1" padding={statsPaddingMiddle}>
                                                <HorizontalFlex>
                                                    <FlexChild >
                                                        <P size={infoFontSize1} color={infoFontColor1}>부가세</P>
                                                    </FlexChild>
                                                    <FlexChild justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor1}>
                                                            {/* 부가세가 있으면 '-' 기호를 붙임 */}
                                                            {vat ? '- ' : ''}
                                                            {/* 부가세의 절댓값을 취하고 숫자를 포맷팅하여 출력 */}
                                                            {Math.abs(vat).toLocaleString()}
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild flex="1" padding={statsPaddingEnd}>
                                                <HorizontalFlex>
                                                    <FlexChild flex="3">
                                                        <P size={infoFontSize1} color={infoFontColor3}>이번달 정산예정 금액</P>
                                                    </FlexChild>
                                                    <FlexChild flex="1" justifyContent={contentEnd}>
                                                        <P weight={commonFontWeight700} size={infoFontSize1} color={infoFontColor2}>
                                                            {monthSettlementAmount ? monthSettlementAmount.toLocaleString() : 0}
                                                        </P>
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </div>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                {/* 빈 공간용 더미, 이게 없으면 높이 무너짐 */}
                <FlexChild></FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default VendorCalc;